if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('.collection-tabs__tab')];
      this.panels = [...this.querySelectorAll('.collection-tabs__panel')];

      this.tabs.forEach((tab, index) => tab.addEventListener('click', () => this.select(index)));
      this.panels.forEach((panel) => this.setupSlider(panel));
      this.setupSwatches();
    }

    select(index) {
      this.tabs.forEach((tab, i) => tab.setAttribute('aria-selected', String(i === index)));
      this.panels.forEach((panel, i) => {
        panel.hidden = i !== index;
        if (i === index) {
          const track = panel.querySelector('.collection-tabs__track');
          track.scrollTo({ left: 0, behavior: 'instant' });
          this.updateArrows(panel);
        }
      });
    }

    setupSlider(panel) {
      const track = panel.querySelector('.collection-tabs__track');
      panel.querySelectorAll('.collection-tabs__arrow').forEach((arrow) => {
        arrow.addEventListener('click', () => {
          const card = track.querySelector('.collection-tabs__card');
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          const step = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
          track.scrollBy({ left: step * Number(arrow.dataset.dir), behavior: 'smooth' });
        });
      });
      track.addEventListener('scroll', () => this.updateArrows(panel), { passive: true });
      this.updateArrows(panel);
    }

    updateArrows(panel) {
      const track = panel.querySelector('.collection-tabs__track');
      const prev = panel.querySelector('.collection-tabs__arrow--prev');
      const next = panel.querySelector('.collection-tabs__arrow--next');
      const max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }

    // Hovering a swatch previews that colour's image on the card.
    setupSwatches() {
      this.querySelectorAll('.collection-tabs__card').forEach((card) => {
        const img = card.querySelector('.collection-tabs__img--primary');
        if (!img || img.tagName !== 'IMG') return;
        const originalSrc = img.getAttribute('src');
        const originalSrcset = img.getAttribute('srcset');

        card.querySelectorAll('.collection-tabs__swatch[data-swatch-src]').forEach((swatch) => {
          swatch.addEventListener('mouseenter', () => {
            card.classList.add('is-swatch-active');
            img.removeAttribute('srcset');
            img.src = swatch.dataset.swatchSrc;
          });
          swatch.addEventListener('mouseleave', () => {
            card.classList.remove('is-swatch-active');
            img.src = originalSrc;
            if (originalSrcset) img.setAttribute('srcset', originalSrcset);
          });
        });
      });
    }
  }

  customElements.define('collection-tabs', CollectionTabs);
}
